module.exports = __webpack_public_path__ + "static/media/gift-card-custom.a95ae551.svg";